var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContainerSimbols',{attrs:{"color":_vm.backgroundColor}},[_c('v-col',{attrs:{"cols":"11","md":"5","lg":"6"}},[_c('v-card',{attrs:{"id":"message"}},[_vm._t("messages"),_c('br'),_vm._t("actions")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }